import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { Resource, ResourceAction } from '@enmon/commons/lib/shared/permissions';
import { APP_DICTIONARY } from '../root';

export const RESOURCES_TRANSLATED = defineMessages<Resource>({
  [Resource.Customers]: APP_DICTIONARY.customers,
  [Resource.Establishments]: APP_DICTIONARY.establishments,
  [Resource.Invoices]: { id: 'app.common.resources.invoices' },
  [Resource.Meters]: APP_DICTIONARY.meters,
  [Resource.Readings]: { id: 'app.common.resources.readings' },
  [Resource.SupplyPoints]: APP_DICTIONARY.supplyPoints,
  [Resource.Users]: APP_DICTIONARY.users,
  [Resource.Tenants]: APP_DICTIONARY.tenants,
  [Resource.LeaseUnits]: { id: 'app.common.resources.leaseUnits' },
});

export const RESOURCE_ACTIONS_TRANSLATED = defineMessages<ResourceAction>({
  [ResourceAction.Create]: { id: 'app.common.resourceActions.create' },
  [ResourceAction.Read]: { id: 'app.common.resourceActions.read' },
  [ResourceAction.Update]: { id: 'app.common.resourceActions.update' },
  [ResourceAction.Delete]: { id: 'app.common.resourceActions.delete' },
});
